module.exports = __webpack_public_path__ + "ca355f1c96d88db039d0d24cdfef8a5c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-4.png
// module id = 2297
// module chunks = 0